import { useFormContext, useFormState, useWatch } from "react-hook-form";

import {
  ELEMENT_WRAPPER_MB,
  ElementWrapper,
  ErrorMessage,
  InputText,
  Label,
  createValidation,
  getErrorMessage,
} from "@up/form";
import { CountryOptions } from "@up/ui";

import type { TErrorMessageKey } from "@up/form";

export function StudentPhoneNumber({
  label = "Student Phone Number (Mobile/Cell Preferred)",
}: {
  label?: string;
}) {
  const { register } = useFormContext();
  const { errors } = useFormState();
  const formValues = useWatch();

  const KEY = "student-phone-number";
  const ERROR_ID = KEY + "-error-message";
  const VALIDATION = { presence: true };
  const PHONE_ERROR = errors[KEY];
  const COUNTRY_CODE_ERROR = errors[KEY + "-country-code"];

  return (
    <ElementWrapper
      className={ELEMENT_WRAPPER_MB}
      hasErrors={!!PHONE_ERROR || !!COUNTRY_CODE_ERROR}
    >
      <Label htmlFor={KEY} required={true} text={label} />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
        }}
      >
        <select
          className="kup-select kup-select-arrow"
          {...register(
            KEY + "-country-code",
            createValidation(VALIDATION, formValues),
          )}
          style={{
            width: "8.25rem",
          }}
        >
          <CountryOptions />
        </select>
        <InputText
          aria-describedby={PHONE_ERROR ? ERROR_ID : null}
          className="kup-input-text-phone"
          registerProps={register(
            KEY,
            createValidation(VALIDATION, formValues),
          )}
        />
      </div>
      <ErrorMessage
        id={ERROR_ID}
        text={
          PHONE_ERROR
            ? getErrorMessage(PHONE_ERROR.type as TErrorMessageKey, VALIDATION)
            : null
        }
      />
      <ErrorMessage
        id={ERROR_ID}
        text={
          COUNTRY_CODE_ERROR
            ? getErrorMessage(
                COUNTRY_CODE_ERROR.type as TErrorMessageKey,
                VALIDATION,
              )
            : null
        }
      />
    </ElementWrapper>
  );
}
